/** 待办进程 tab 内 AdvanceTable 默认分页与页脚 */
export const PENDING_TABLE_PER_PAGE = 7;

/** 各待办 tab 列表行主题色（圆点、状态列、编号链接；tab 角标仍为红色 danger） */
export const PENDING_TAB_BADGE = {
	contract: 'warning',
	delivering: 'warning',
	accepting: 'info',
	accountsReceivable: 'warning',
	finalCostVerification: 'primary',
	prePayment: 'danger',
	applying: 'danger',
	rejected: 'danger',
	approving: 'danger',
	recent: 'info',
};
